export enum DashboardSource {
  activeBranch = 'activeBranch',
  tenant = 'tenant',
}
